import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 24px;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 1rem;
    row-gap: 1rem;
  }

  @media (max-width: 480px) {
    padding: 0.75rem;
    row-gap: 0.75rem;
  }
`;

export const TitleText = styled.div`
  color: #4d4d4d;
  font-size: 1.5rem;
  line-height: 1.25;
  font-weight: 600;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }

  @media (max-width: 480px) {
    font-size: 1.1rem;
    padding: 0 0.5rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  width: 100%;
  max-width: calc(100% / 3);
  max-height: 50vh;
  overflow-y: auto;
  padding: 4px 16px;

  /* 自定義滾動條樣式 */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;

    &:hover {
      background: rgba(255, 255, 255, 0.5);
    }
  }

  /* Firefox 滾動條樣式 */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1);

  @media (max-width: 1024px) {
    max-width: calc(100% / 2);
  }

  @media (max-width: 768px) {
    max-width: 70%;
    gap: 1rem;
    padding: 4px 8px;
  }

  @media (max-width: 480px) {
    max-width: 90%;
    gap: 0.75rem;
    padding: 4px;
    max-height: 60vh;
  }
`;

export const QuestionnaireItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;

  .questionnaire-item {
    width: 100%;
    transition:
      width 200ms ease-in-out,
      min-width 200ms ease-in-out;
  }

  .questionnaire-action-wrapper {
    width: 0%;
  }

  /* Desktop hover effect */
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      .questionnaire-item {
        width: calc(100% - 5rem - 8px);
        min-width: calc(100% - 5rem - 8px);
      }

      .questionnaire-action-wrapper {
        opacity: 1;
        width: 5rem;
      }
    }
  }

  /* Mobile touch devices - always show delete button */
  @media (hover: none) and (pointer: coarse) {
    .questionnaire-item {
      width: calc(100% - 5rem - 8px);
      min-width: calc(100% - 5rem - 8px);
    }

    .questionnaire-action-wrapper {
      opacity: 1;
      width: 5rem;
    }
  }

  /* Small mobile screens - stack vertically or show smaller buttons */
  @media (max-width: 480px) {
    gap: 8px;

    @media (hover: none) and (pointer: coarse) {
      .questionnaire-item {
        width: calc(100% - 5rem - 8px);
        min-width: calc(100% - 5rem - 8px);
      }

      .questionnaire-action-wrapper {
        width: 5rem;
      }
    }
  }
`;

export const QuestionnaireActionWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: end;
  column-gap: 4px;
  opacity: 0;
  top: 50%;
  right: 0;
  overflow: hidden;
  transform: translateY(-50%);
  transition:
    opacity 200ms ease-in-out,
    width 200ms ease-in-out;

  /* Mobile - adjust button size */
  @media (max-width: 480px) {
    column-gap: 2px;

    button {
      font-size: 0.875rem;
    }
  }
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    gap: 0.75rem;
    margin-top: 1.5rem;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1rem;
    width: 100%;
  }
`;
